(function ($) {


    $('.gallery-list-row .load-more').on('click', function() {
        //show more images on click of load more button
        var moreImages = $('.gallery-list-row').find('.d-none');
        var firstHiddenImage = moreImages.first();
        var key = parseFloat(firstHiddenImage.attr('id'))
        

        for(var i=0; i<6; i++) {
            var newKey = i+key;
            var showImages = $(`#${newKey}`)
            showImages.removeClass("d-none").addClass("d-flex")
        }

        // const tl = new TimelineMax();

        // for(var i=0; i<6; i++) {
        //     tl.fromTo(showImages[i], .3, {scale: .7, opacity: 0}, {scale: 1, opacity: 1})
        // }

        // hide the load more button
        if(!$('.gallery-list-row .card').hasClass('d-none')) {
            $(this).addClass("d-none");
        }
        
    })

})(jQuery);